import { render, staticRenderFns } from "./HealthcareChallenges.vue?vue&type=template&id=0e299223&scoped=true&"
import script from "./HealthcareChallenges.vue?vue&type=script&lang=js&"
export * from "./HealthcareChallenges.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareChallenges.vue?vue&type=style&index=0&id=0e299223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e299223",
  null
  
)

export default component.exports